var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('p',{staticStyle:{"margin-left":"35%","margin-top":"15%"}},[_vm._v(" This one is in to do list will have to start soon")])])
}]

export { render, staticRenderFns }